import ComponentManager from "../../componentFramework";
import Dialog from "../Dialog";
import Button from "../Button";
import PrimeFacesFileUpload from "../PrimeFaces/PrimeFacesFileUpload";
import JsfJsCommand from "../JsfJsCommand";

@ComponentManager.register()
export default class UploadFilesDialog extends Dialog {
	public static componentStyleClass = "uploadFilesDialog";

	constructor(rootElement: HTMLElement) {
		super(rootElement);
		this.eventListenerManager.manage(this).addEventListener("stepChange", () => {
			this.setupDialogStep();
		});
	}

	@ComponentManager.on("ready")
	protected componentReady() {
		this.setupDialogStep();
	}

	protected setupDialogStep() {
		const fileUpload = this.getPrimeFacesFileUpload();
		const uploadButton = this.getUploadButton();
		if (fileUpload !== undefined && uploadButton !== undefined) {
			const managedFileUpload = this.eventListenerManager.manage(fileUpload);
			managedFileUpload.addEventListener("fileListChange", data => {
				this.getUploadButton()?.setDisabled(data.files.length === 0);
			});
			managedFileUpload.addEventListener("uploadQueueComplete", () => {
				// Upload is done. Move to next step in dialog's process.
				JsfJsCommand.run("uploadFilesProcessFiles", this.rootElement);
			});

			uploadButton.setPreventDefaultOnClick(true);
			this.eventListenerManager.manage(uploadButton).addEventListener("click", () => {
				this.getPrimeFacesFileUpload()?.upload();
			});

			fileUpload.setUploadButtonVisibility(false);
		}
		this.eventListenerManager.cleanupListeners();
	}

	private getPrimeFacesFileUpload(): PrimeFacesFileUpload | undefined {
		return ComponentManager.queryForComponent(this.getRootElement(), PrimeFacesFileUpload);
	}

	private getUploadButton(): Button | undefined {
		return ComponentManager.queryForComponent(this.getRootElement(), Button, ".uploadFilesDialog__uploadButton");
	}
}
